import {
  Container,
  Stack,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Text } from "../components/Text";
import { TopAbout } from "../components/TopAbout";
import { CompanyDetail } from "../components/CompanyDetail";

export const Company = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack>
      <Stack
        justifyContent="center"
        sx={{
          backgroundImage: isMobile
            ? "url(/images/company-kv_sp.png)"
            : "url(/images/company-kv.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: isMobile ? 200 : 320,
        }}
      >
        <Container>
          <Text variant="h1" fontSize={40} color="#fff">
            会社概要
          </Text>
          <Text
            variant="h2"
            marginTop={1}
            color="#fff"
            sx={{
              fontSize: isMobile ? "22px !important" : 28,
            }}
          >
            Company
          </Text>
        </Container>
      </Stack>
      <TopAbout title="Vision">
        <Stack>
          <Text
            variant="h3"
            color="primary"
            marginTop={isMobile ? 2 : 6.5}
            lineHeight={1.5}
          >
            「微生物の可能性を引き出し、{isMobile ? <br /> : null}
            持続可能な未来を創る」
          </Text>
          <Text marginTop={isMobile ? 2 : 3.8}>
            MycoGenomeは、真菌（微生物）の可能性を最大限に活用し、
            <br />
            食品・農業・医療・環境・エネルギーといった多様な分野でイノベーションを起こすことを目指しています。
            <br />
            私たちは、従来のゲノム編集技術の限界を超え、
            <br />
            非遺伝子組換え型の安全かつ高精度な微生物改変技術を提供することで、社会の持続可能な発展に貢献します。
            <br />
            微生物バイオテクノロジーの新たな可能性を切り拓き、
            <br />
            産業界とともに未来の社会を構築することが私たちのビジョンです。
          </Text>
        </Stack>
      </TopAbout>
      <TopAbout
        title="Mission"
        background="#f6f6f6"
        image="/images/mission.png"
      >
        <Stack>
          <Stack>
            <Text
              variant="h3"
              color="primary"
              marginTop={isMobile ? 2 : 6.5}
              lineHeight={1.5}
            >
              「真菌ゲノム編集技術で産業を革新し、
              {isMobile ? null : <br />}
              社会課題を解決する」
            </Text>

            <List sx={{ marginTop: isMobile ? 2 : 4 }}>
              {[
                "食品の発酵技術を進化させ、食の未来を創る",
                "農業・畜産分野で持続可能な生産技術を支援する",
                "バイオ燃料の効率化に貢献し、環境負荷を低減する",
                "医薬品・化学分野で有用な微生物開発を促進する",
              ].map((text, index) => {
                return (
                  <ListItem
                    key={index}
                    sx={{
                      padding: 0,
                      "&::before": {
                        content: "'⚫︎'",
                        color: "#ffbd00",
                        paddingRight: 1,
                      },
                    }}
                  >
                    <Text lineHeight={1.7} fontWeight="bold">
                      {text}
                    </Text>
                  </ListItem>
                );
              })}
            </List>

            <Text marginTop={2}>
              MycoGenomeは、独自の「MycoEdita」技術を活用し、
              <br />
              これまでにないゲノム編集手法を確立。
              <br />
              従来のCRISPR/Cas9技術に依存せず、
              <br />
              産業応用に適した非遺伝子組換え型の技術を提供することで、
              <br />
              微生物バイオテクノロジーの新たな市場を創出します。
            </Text>
          </Stack>
        </Stack>
      </TopAbout>
      <CompanyDetail />
    </Stack>
  );
};
